import { memo } from "react";
import { Box, Typography, LinearProgress, Stack } from "@mui/material";
import { IServiceQuality } from "../../../interfaces/dashboard";
import { formatRate } from "../../../utils/metricsFormatters";
import {
  getPositiveMetricSeverity,
  getNegativeMetricSeverity,
  SEVERITY_COLOR,
} from "../../../utils/MetricThresholds";

interface IServiceQualityProps {
  data: IServiceQuality;
}

const QualityBar = ({
  label,
  value,
  color,
}: {
  label: string;
  value: number;
  color: string;
}) => (
  <Box>
    <Box display="flex" justifyContent="space-between" mb={0.5}>
      <Typography variant="body2">{label}</Typography>
      <Typography variant="body2" fontWeight={600} color={color}>
        {formatRate(value)}
      </Typography>
    </Box>
    <LinearProgress
      variant="determinate"
      value={value}
      sx={{
        height: 10,
        borderRadius: 1,
        backgroundColor: "#f5f5f5",
        "& .MuiLinearProgress-bar": { backgroundColor: color },
      }}
    />
  </Box>
);

const ServiceQuality = ({ data }: IServiceQualityProps) => (
  <Stack spacing={2}>
    <QualityBar
      label="Entregas a tiempo"
      value={data.onTimeRate}
      color={SEVERITY_COLOR[getPositiveMetricSeverity(data.onTimeRate)]}
    />
    <QualityBar
      label="Entregas exitosas"
      value={data.successRate}
      color={SEVERITY_COLOR[getPositiveMetricSeverity(data.successRate)]}
    />
    <QualityBar
      label="Envíos no entregados"
      value={data.notDeliveredRate}
      color={SEVERITY_COLOR[getNegativeMetricSeverity(data.notDeliveredRate)]}
    />
    <QualityBar
      label="Devoluciones"
      value={data.returnedRate}
      color={SEVERITY_COLOR[getNegativeMetricSeverity(data.returnedRate)]}
    />
  </Stack>
);

export default memo(ServiceQuality);
